import React, { useContext } from 'react';
import getSourceHeaderCopy from 'components/Mappings/_helpers/getSourceHeaderCopy';
import MappingProps, * as MappingTypes from 'types/Mapping';
import MappingsContext from 'helpers/MappingsContext';

import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Table from 'components/Table';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableBody from '@material-ui/core/TableBody';
import MappingsRow from 'components/Mappings/MappingsRow';

interface Props {
  mappings: MappingProps[];
  onDeleteMapping: (indexToDelete: number) => void;
  onUpdateMapping: (newMappingIndex: number, newMapping: MappingProps) => void;
}

function PrimaryKeyMapping({ mappings, onDeleteMapping, onUpdateMapping }: Props) {
  const mappingContext: MappingTypes.MappingContext = useContext(MappingsContext);
  const { source } = mappingContext;
  const { isPrimary, type } = source;

  return (
    <>
      <CardHeader
        title={'Unique Identifier'}
        subheader={
          <div style={{ marginTop: 4 }}>
            {isPrimary ? (
              <div>
                The Unique Identifier defines a person’s identity in Sift. It should be something
                that is unique to each imported person, and should ideally never change. We
                recommend something like an employee id, but if that’s not available you could also
                use something like an email address or a full name.
              </div>
            ) : (
              <div>
                The Unique Identifier defines a person’s identity in Sift and is used to connect
                data from this data source to the profiles created from your Primary source. The
                values in this property should match the associated unique identifiers provided in
                the primary source.
              </div>
            )}

            <div style={{ marginTop: 24 }}>
              <strong>Note:</strong> This cannot be changed after your first sync without contacting
              our support team.
            </div>
          </div>
        }
      />
      <CardContent>
        <Table>
          <TableHead>
            <TableHeadCell>{getSourceHeaderCopy(type)}</TableHeadCell>
            <TableHeadCell>Preview</TableHeadCell>
            <TableHeadCell colSpan={2} />
          </TableHead>
          <TableBody>
            {mappings.map((mapping: MappingProps, index: number) => {
              return (
                <MappingsRow
                  key={index}
                  mapping={mapping}
                  rowIndex={index}
                  onDeleteMapping={onDeleteMapping}
                  onUpdateMapping={onUpdateMapping}
                />
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </>
  );
}

export default PrimaryKeyMapping;
